import { PerformanceList } from "app/performance/PerformanceList/PerformanceList";
import React from "react";

import { Box, ColumnContainer } from "app/layout/components";
import { FinanceKnowledgeContainer } from "app/financeKnowledge/FinanceKnowledgeContainer/FinanceKnowledgeContainer";
import { AdContainer } from "app/thirdParty/ads/AdContainer";
import { AdTypes } from "app/thirdParty/ads/interfaces";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";

export interface InstrumentPerformanceProps {
    /** Title of the share to be printed as headline */
    name: string;
    periods?: {
        label: string;
        value: number;
    }[];
    years?: {
        label: string;
        value: number;
    }[];
}

/**
 * This component renders the share name as main headline
 * as well as a list of attributes for the share.
 */
export const InstrumentPerformance = ({ name, periods, years }: InstrumentPerformanceProps) => {
    return (
        <Box section className="instrumentPerformance">
            <SectionHeader headline={`Wertentwicklung ${name}`} />
            <FinanceKnowledgeContainer knowledgeKey="whatIsValueDevelopment" />
            <ColumnContainer>
                {periods && <PerformanceList headline="Periode" items={periods} />}
                {years && <PerformanceList headline="Jahr" items={years} />}
                <AdContainer type={[AdTypes.MREC2]} />
            </ColumnContainer>
        </Box>
    );
};
